import {Base} from "./base";

class YyghService extends Base {
  constructor() {
    super();
  }

  /**
   * 就诊人绑定的所有就诊卡
   * @param compatId
   * @param hosid
   * @returns {Promise<[]>}
   */
  async menzhenjlQueryAlljzkh(compatId, hosid) {
    const {cardIds = []} = await this.$http('zheer.yygh.ApiJyjcService.menzhenjlQueryAlljzkh', {
      compatId, hosid, orgid: hosid
    });
    return cardIds;
  }

  /**
   * 入院办理记录查询
   * @param orgid
   * @param bingah
   * @returns {Promise<void>}
   */
  async queryInHospitalStatus({orgid, bingah}) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryInHospitalStatus', {
      hosid: orgid, orgid, bingah
    }, {}, {
      showError: false
    })
    return list;
  }

  /**
   * 住院证查询
   * @returns {Promise<*[]>}
   */
  async queryInHospitalCard({orgid, bingah}) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryInHospitalCard', {
      hosid: orgid, orgid, bingah
    })
    list.map(r => {
      r._zt = (zt => {
        if (zt !== '' && ['0', '1', '2', '3', '4'].includes(zt)) {
          return '1'
        }
        return '0'
      })(r.zYYYZT)
    })
    return list;
  }

  /**
   * 入院记录提交
   * @param orgid
   * @param bingah
   * @param applyNumber
   * @param whiteBloodCell
   * @param whiteBloodCellDate
   * @param mensesDate
   * @param medicinal
   * @param remark
   * @param examTime
   * @param diastolicPressure
   * @param systolicPressure
   * @param personalNeed
   * @param bedType
   * @param applyHospitalDate
   * @returns {Promise<void>}
   */
  async recordInHospitalRemark({
                                 orgid,
                                 bingah,
                                 bedType,
                                 applyHospitalDate,
                                 applyNumber,
                                 whiteBloodCell,
                                 whiteBloodCellDate,
                                 mensesDate,
                                 medicinal,
                                 remark,
                                 examTime,
                                 diastolicPressure,
                                 systolicPressure,
                                 personalNeed
                               }) {
    const {code} = await this.$http('zheer.yygh.ApiJyjcService.recordInHospitalRemark', {
      orgid,
      hosid: orgid,
      bingah,
      bedType,
      applyHospitalDate,
      applyNumber,
      whiteBloodCell,
      whiteBloodCellDate,
      mensesDate,
      medicinal,
      remark,
      examTime,
      diastolicPressure,
      systolicPressure,
      personalNeed
    })
    return code;
  }

  /**
   * 校验身份证地址手机号格式
   * @param hosid
   * @param compatId
   * @returns {Promise<{}>}
   * {"bINGANH":"11734399","bINGLIBH":"11734399","bINGRENLB":"1","bINGRENXZ":"0","bINGRENXZMC":"自费","cHUSHENGRQ":"1996-02-21","code":"0","gERENBH":"","hISBRXX":"990190030007152494%1%0%%%11734399%车欢欢%2%%1996-02-21%1%610425199602210923%%0%%陕西省礼泉县药王洞乡井泉村四组%1%0%0%0%%%%1%%","jIATINGZZ":"陕西省礼泉县药王洞乡井泉村四组","jIUZHENKH":"990190030007152494","lIANXIDH":"15229605766","msg":"","rENYUANLB":"1","succ":true,"xINGBIE":"2","xINGMING":"车欢欢","yIBAOBRXX":"","yIBAOKH":"","zHENGJIANHM":"610425199602210923","zHENGJIANLX":"1"}
   */
  async apiPatientServiceCheckPhoneAndAddress({hosid, compatId}) {
    const obj = await this.$http('zheer.yygh.ApiPatientService.checkPhoneAndAddress', {
      hosid, compatId
    })
    return obj;
  }

  /**
   * 校验身份证地址手机号格式v2
   * @param hosid
   * @param compatId
   * @param filtering vitalSigns|mobile|address
   * @returns {Promise<{}>}
   * {"bINGANH":"11734399","bINGLIBH":"11734399","bINGRENLB":"1","bINGRENXZ":"0","bINGRENXZMC":"自费","cHUSHENGRQ":"1996-02-21","code":"0","gERENBH":"","hISBRXX":"990190030007152494%1%0%%%11734399%车欢欢%2%%1996-02-21%1%610425199602210923%%0%%陕西省礼泉县药王洞乡井泉村四组%1%0%0%0%%%%1%%","jIATINGZZ":"陕西省礼泉县药王洞乡井泉村四组","jIUZHENKH":"990190030007152494","lIANXIDH":"15229605766","msg":"","rENYUANLB":"1","succ":true,"xINGBIE":"2","xINGMING":"车欢欢","yIBAOBRXX":"","yIBAOKH":"","zHENGJIANHM":"610425199602210923","zHENGJIANLX":"1"}
   */
  async apiPatientServiceCheckPhoneAndAddressV2({hosid, compatId, filtering}) {
    const obj = await this.$http('zheer.yygh.ApiPatientService.checkPhoneAndAddress.v2', {
      hosid, compatId, filtering
    })
    return obj;
  }

  /**
   * 手术记录Id
   * @param options
   * @param options.compatMedicalRecord
   * @param options.strartDate
   * @param options.endDate
   * @param options.orgid
   * @returns {Promise<[]>}
   */
  async apiDaySurgeryServiceDaySurgeryList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiDaySurgeryService.daySurgeryList', {...options});
    return list;
  }

  /**
   * 手麻手术
   * @param options
   * @param options.PATID
   * @param options.STARTTIME
   * @param options.ENDTIME
   * @param options.orgid
   * @returns {Promise<[]>}
   */
  async apiDaySurgeryServiceSurgeryList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiDaySurgeryService.surgeryList', {
      ...options
    });
    return list;
  }

  /**
   * 手麻手术进度
   * @param options
   * @param options.PATID
   * @param options.SSXH
   * @param options.orgid
   * @returns {Promise<string>}
   */
  async apiDaySurgeryServiceSurgeryInfo(options) {
    const {state = ''} = await this.$http('zheer.yygh.ApiDaySurgeryService.surgeryInfo', options)
    return state;
  }

  /**
   * 手麻手术进度
   * @param options
   * @param options.PATID
   * @param options.SSXH
   * @param options.orgid
   * @returns {Promise<{}>}
   */
  async apiDaySurgeryServiceSurgeryInfoV2(options) {
    const {surgerySchedule = {}} = await this.$http('zheer.yygh.ApiDaySurgeryService.surgeryInfo.v2', options)
    return surgerySchedule;
  }

  /**
   * 其他平台预约记录
   * @param compatId
   * @param orgid
   * @returns {Promise<[]>}
   */
  async apiOrderServiceQueryUserOrderListAll(compatId, orgid) {
    const {list = []} = await this.$http('zheer.yygh.apiOrderService.queryUserOrderListAll', {compatId, orgid});
    return list;
  }

  /**
   * 其他平台挂号记录取消
   * @param options
   * @param options.hosid
   * @param options.orgid
   * @param options.compatId
   * @param options.qhmm
   * @returns {Promise<{code}>}
   */
  async apiOrderServiceHospitalOrderCancel(options) {
    return await this.$http('zheer.yygh.apiOrderService.hospitalOrderCancel', {
      ...options
    });
  }

  /**
   * 待安排的检查列表
   * @param options
   * @param options.bingah
   * @param options.zyh
   * @param options.hosid
   * @param options.orgid
   * @returns {Promise<[]>}
   */
  async apiJyjcServiceToBeInspectList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.toBeInspectList', options);
    return list;
  }

  /**
   * 待安排的检验列表
   * @param options
   * @param options.bingah
   * @param options.zyh
   * @param options.hosid
   * @param options.orgid
   * @returns {Promise<[]>}
   */
  async apiJyjcServiceToBeExamList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.toBeExamList', options);
    return list;
  }

  async apiSchoolHosServiceXyyGhDeptList() {
    const {list = []} = await this.$http('zheer.yygh.ApiSchoolHosService.xyyGhDeptList', {})
    return list;
  }

  /**
   * 排班列表
   * @param options
   * @param options.date
   * @param options.deptid
   * @param options.docid
   * @returns {Promise<[]>}
   */
  async apiSchoolHosServiceXyySchemeList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiSchoolHosService.xyySchemeList', options)
    return list;
  }

  /**
   * 号源列表
   * @param options
   * @param options.date
   * @param options.ampm
   * @param options.docid
   * @param options.deptid
   * @returns {Promise<[]>}
   */
  async apiSchoolHosServiceXyyNumList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiSchoolHosService.xyyNumList', options)
    return list;
  }

  /**
   *
   * @param options
   * @param options.date
   * @param options.ampm
   * @param options.deptid
   * @param options.docid
   * @param options.numId
   * @param options.bah
   * @param options.patId
   * @param options.compatId
   * @returns {Promise<{code,qhmm}>}
   */
  async apiSchoolHosServiceXyyRegister(options) {
    return await this.$http('zheer.yygh.ApiSchoolHosService.xyyRegister', options)
  }

  /**
   * 校医院订单列表
   * @param options
   * @param options.pageIndex
   * @param options.pageSize
   * @param options.hzid
   * @returns {Promise<[]>}
   */
  async apiSchoolHosServiceXyyOrderList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiSchoolHosService.xyyOrderList', options)
    return list;
  }

  /**
   * 校医院-订单取消
   * @param orderId
   * @returns {Promise<string>}
   */
  async apiSchoolHosServiceXyyCancel(orderId) {
    const {code = '0'} = await this.$http('zheer.yygh.ApiSchoolHosService.xyyCancel', {orderId});
    return code;
  }


  /**
   * 体检支付预结算
   * @param tijiankh
   * @returns {Promise<T>}
   */
  async apiPersonalExamServicePreSettlement(tijiankh) {
    return await this.$http('zheer.yygh.ApiPersonalExamService.preSettlement', {
      tijiankh
    })
  }

  /**
   * 体检支付预结算
   * @param jzkh
   * @param hosid
   * @param orgid
   * @param jiesuanId
   * @returns {Promise<T>}
   */
  async apiPersonalExamServicePreSettlementV2({jzkh, hosid, orgid, jiesuanId}) {
    return await this.$http('zheer.yygh.ApiPersonalExamService.preSettlement.v2', {
      jzkh, hosid, orgid, jiesuanId
    })
  }

  /**
   * 体检院内支付
   * @param options
   * @param options.orderId
   * @param options.returnUrl
   * @param options.compatId
   * @returns {Promise<T>}
   */
  async apiPersonalExamServiceExamPayment(options) {
    return await this.$http('zheer.yygh.ApiPersonalExamService.examPayment', options);
  }

  /**
   * 体检院内-支付
   * @param hosid
   * @param orgid
   * @param jiesuanId
   * @param zflsh
   * @param returnUrl
   * @param totalFee
   * @param compatId
   * @returns {Promise<void>}
   */
  async apiPersonalExamServiceExamPaymentV2({zflsh, returnUrl, totalFee, hosid, orgid, jiesuanId, compatId}) {
    return await this.$http('zheer.yygh.ApiPersonalExamService.examPayment.v2', {
      zflsh,
      returnUrl,
      totalFee,
      hosid,
      orgid,
      jiesuanId,
      compatId
    });
  }

  /**
   * 修改生命体质
   * @param options
   * @param options.jzkh
   * @param options.bingAnH
   * @param options.height
   * @param options.weight
   * @param options.hosid
   * @param options.orgid
   * @returns {Promise<string>}
   */
  async apiPatientServiceChangeHisVitalSigns(options) {
    const {code = ''} = await this.$http('zheer.yygh.apiPatientService.changeHisVitalSigns', options)
    return code;
  }

  /**
   *
   * @param options
   * @param options.compatMedicalRecord
   * @param options.startDate
   * @param options.endDate
   * @returns {Promise<[]>}
   */
  async inpatientServicesList(options) {
    const {list = []} = await this.$http('zheer.yygh.ApiInpatientServicesService.inpatientServicesList', options)
    return list;
  }

  /**
   *
   * @param options
   * @param options.compatMedicalRecord
   * @param options.zyh
   * @returns {Promise<string>}
   */
  async apiInpatientServicesServiceStatus(options) {
    const {pROGRESS} = await this.$http('zheer.yygh.ApiInpatientServicesService.status', options)
    return pROGRESS;
  }

  /**
   *
   * @param options
   * @param options.compatMedicalRecord
   * @param options.zyh
   * @returns {Promise<{list, needCompleteList}>}
   */
  async hospitalExamList(options) {
    const {
      list = [],
      needCompleteList = []
    } = await this.$http('zheer.yygh.ApiHospitalExaminationService.hospitalExamList', options)
    return {list, needCompleteList};
  }

  /**
   * 获取患者院内建档信息
   * @param options
   * @param options.hosid
   * @param options.compatId
   * @returns {Promise<void>}
   */
  async getPatientHisInfo(options) {
    return await this.$http('zheer.yygh.ApiPatientService.getPatientInfo', options);
  }

  /**
   * 设置院内患者信息
   * @param options
   * @param options.orgid
   * @param options.compatId
   **/
  async setPatientHisInfo(options) {
    return await this.$http('zheer.yygh.apiPatientService.changeHisPatientData', options);
  }
}

export const yyghService = new YyghService();



// WEBPACK FOOTER //
// ./src/services/yygh.js